<template>
  <div class="q-pa-md">
    <q-card class="my-card" flat bordered>
      <q-item>
        <q-item-section avatar>
          <q-icon name="people" />
        </q-item-section>
        <q-item-section>
          <q-item-label>Danisanlar</q-item-label>
        </q-item-section>
      </q-item>
      <q-separator />
      <q-card-section horizontal>
        <q-card-section>
          <CreateCustomer />
        </q-card-section>
        <q-separator vertical />
        <q-card-section class="col-4">
          Bu sayfadan sistemde tanimli danisanlari yonetebilirsiniz.
        </q-card-section>
      </q-card-section>
    </q-card>
  </div>
  <div class="q-pa-md">
    <CustomerSearch />
  </div>
  <div class="q-pa-md">
    <CustomersTable />
  </div>
</template>
<script>
import CreateCustomer from '../components/customers/Create.vue'
import CustomerSearch from '../components/customers/Search.vue'
import CustomersTable from '../components/customers/Table.vue'

export default {
  components: {
    CreateCustomer,
    CustomersTable,
    CustomerSearch,
  },
  setup() {
    return {}
  },
}
</script>
